<template>
	<footer>
		<section
			class="footer-request-form"
			:class="$route.name == 'Home' && 'footer-request-form_home'"
			id="footer-request-form"
		>
			<div class="container">
				<RequestForm />
			</div>
		</section>

		<section class="footer-tagline">
			<div class="container">
				<div class="footer-tagline__content">
					{{ $t('company.slogan') }}
				</div>
			</div>
		</section>

		<div class="footer d-none d-md-block">
			<div class="container">
				<div class="footer__top row align-items-center">
					<div class="col col-xl-auto mr-auto">
						<router-link :to="{ name: 'Home' }">
							<img
								class="footer__logo"
								:src="`/img/logo-light_${$i18n.locale}.svg`"
								:alt="$t('company.name')"
							/>
						</router-link>
					</div>
					<div class="col-auto pr-0">
						<a
							class="footer__phone-link btn-circle"
							:href="'tel:' + $t('company.phone')"
							@click="fbqContact()"
						>
							<i class="icon icon-phone"></i>
						</a>
					</div>
					<div class="col-auto">
						<button
							class="footer__call-btn btn-primary small"
							@click="togglePopup('requestForm')"
						>
							<i class="gradient"></i> {{ $t('discussProject') }}
						</button>
					</div>
				</div>

				<div class="footer__links row flex-wrap align-items-center">
					<div class="footer__links-item col-auto mr-auto">
						<nav class="footer-menu">
							<router-link
								class="footer-menu__item"
								v-for="(item, i) in menu"
								:key="i"
								:to="item.to"
								:class="{ disabled: item.disabled }"
								>{{ item.name }}</router-link
							>
						</nav>
					</div>
					<div class="footer__links-item col-auto">
						<div class="footer-socials">
							<a
								class="footer-socials__item"
								v-for="(item, i) in socials"
								:key="i"
								:href="item.link"
								target="_blank"
								@click="fbqContact()"
								><i :class="`icon-${item.icon}`"></i
							></a>
						</div>
					</div>
				</div>

				<div
					class="footer__bottom row align-items-end justify-content-center"
				>
					<div class="col">
						{{ $t('TextITN') }}: {{ $t('company.ITN') }}
						<br>
						{{ $t('TextPSRN') }}: {{ $t('company.PSRN') }}
						<br>
						{{ $t('company.officialName') }}
					</div>

					<div class="col text-right">
						<span
							class="link"
							@click="togglePopup('policyPopup')"
						>
							{{ $t('userAgreement') }}
						</span>
						<br>
						<router-link
							class="link"
							:to="{ name: 'Privacy' }"
						>{{ $t('privacyPolicy') }}</router-link>
						<br>
						Global Code © 2018-{{ new Date().getFullYear() }}
					</div>
				</div>
			</div>
		</div>

		<div class="mobile-footer d-md-none">
			<div class="app-bar-panel">
				<div class="app-bar">
					<router-link
						class="app-bar__item"
						to="/"
					>
						<img
							class="app-bar__icon"
							src="/img/icons/favicon-96x96.png"
							alt=""
							style="padding: 2px"
						/>
						<span>{{ $t('menu.homePage') }}</span>
					</router-link>
					<router-link
						class="app-bar__item"
						v-for="(item, i) in appbarMenu"
						:key="i"
						:class="{ disabled: item.disabled }"
						:to="item.to"
					>
						<i
							class="app-bar__icon"
							:class="`icon-${item.icon}`"
						></i>
						<span>{{ item.name }}</span>
					</router-link>
				</div>
			</div>
		</div>
	</footer>
</template>

<script>
import { mobileApps } from '@/settings'
import RequestForm from '@/components/RequestForm'

export default {
	components: {
		RequestForm,
	},

	data() {
		return {
			mobileApps,
		}
	},

	computed: {
		menu() {
			return [
				{
					name: this.$t('menu.projects'),
					to: { name: 'Projects' },
				},
				{
					name: this.$t('menu.team'),
					to: {},
					disabled: true,
				},
				{
					name: this.$t('menu.services'),
					to: {},
					disabled: true,
				},
				{
					name: this.$t('menu.reviews'),
					to: { name: 'Reviews' },
				},
				{
					name: this.$t('menu.contacts'),
					to: {},
					disabled: true,
				},
			]
		},

		appbarMenu() {
			return [
				{
					icon: 'layers',
					name: this.$t('menu.projects'),
					to: { name: 'Projects' },
				},
				{
					icon: 'messages',
					name: this.$t('menu.reviews'),
					to: { name: 'Reviews' },
				},
				{
					icon: 'contact-card',
					name: this.$t('menu.contactsShort'),
					to: {},
					disabled: true,
				},
			]
		},

		socials() {
			return [
				{
					icon: 'whatsapp-circle',
					link: this.$t('company.whatsapp'),
				},
				{
					icon: 'vk-circle',
					link: this.$t('company.vk'),
				},
				// {
				//   icon: 'facebook-circle',
				//   link: this.$t('company.facebook')
				// },
				// {
				//   icon: 'instagram-circle',
				//   link: this.$t('company.instagram')
				// },
				{
					icon: 'youtube-circle',
					link: this.$t('company.youtube'),
				},
				{
					icon: 'telegram-circle',
					link: this.$t('company.telegram'),
				},
			]
		},
	},

	methods: {
		togglePopup(name, show = true) {
			this.$store.dispatch('general/togglePopup', { name, show })
		},

		fbqContact() {
			fbq('track', 'Contact')
		},
	},
}
</script>

<style lang="scss" scoped>
@import '@/sass/_variables';

.footer-request-form {
	padding-top: 118px;
	padding-bottom: 118px;

	&_home {
		padding-bottom: 0;
	}
}

.footer-tagline {
	padding-top: 66px;
	padding-bottom: 72px;
	text-align: center;
	color: #fff;
	font-size: 50px;
	font-weight: 700;
	line-height: 90px;
}

.link {
	color: #828282;
	cursor: pointer;
	&:hover {
		color: #ffffff;
	}
}

.footer {
	position: relative;
	padding: 56px 0 52px;
	background: #02122b;
	color: #828282;
	letter-spacing: 0.01em;
	&__top {
		margin-bottom: 28px;
	}
	&__call-btn {
		font-size: 18px !important;
		width: 238px !important;
	}
	&__logo {
		width: 256px;
		height: auto;
		display: block;
		max-width: 100%;
	}
	&__phone-link {
		color: #ffffff;
	}
	&__links {
		margin-bottom: 34px;
	}
	&__links-item {
		margin-bottom: 20px;
	}
	&__bottom {
		font-size: 16px;
		line-height: 20px;
	}
}

.page:not(.home) {
	.footer-tagline {
		display: none;
	}
}

.page.theme-light .footer::before,
.page.home .footer::before {
	content: '';
	position: absolute;
	background-repeat: no-repeat;
	background-position: center bottom;
	bottom: 99%;
	left: 0;
	width: 100%;
	z-index: -1;
}
.page.theme-light .footer::before {
	background-image: url('../assets/footer__bg-1.svg');
	height: 180px;
}
.page.home .footer::before {
	background-image: url('../assets/footer__bg-2.svg');
	height: 590px;
}

.footer-menu {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	margin: -9px -18px;
	&__item {
		margin: 9px 18px;
		font-size: 18px;
		font-style: normal;
		font-weight: 600;
		line-height: 36px;
		color: #fff;
		text-decoration: none;
		transition: 0.3s;
		&.disabled {
			// Меню временно недоступно
			color: #343c41;
			pointer-events: none;
		}
		&:hover {
			color: lighten($primary, 10%);
		}
	}
}

.footer-socials {
	display: flex;
	justify-content: center;
	margin: -4px -5px;
	&__item {
		display: flex;
		font-size: 40px;
		border-radius: 100%;
		color: #ffffff;
		text-decoration: none;
		transition: 0.3s;
		margin: 4px 5px;
		&:hover,
		&:focus {
			color: lighten($primary, 10%);
		}
	}
}

$mobile-footer-h: 72px;

.mobile-footer {
	height: $mobile-footer-h;
	position: relative;
	z-index: 10;
	a {
		color: #ffffff;
		&:hover {
			color: lighten(#230a51, 20%);
		}
	}
	.cta-banner {
		margin: 0 0 48px;
	}
}

.app-bar-panel {
	background: linear-gradient(
			90deg,
			rgba(102, 0, 204, 0.33) 5.34%,
			rgba(1, 51, 255, 0.33) 91.03%
		),
		#030f15;
	bottom: 0;
	left: 0;
	width: 100%;
	height: $mobile-footer-h;
	overflow: hidden;
	position: fixed;
	z-index: 20;
	display: flex;
	justify-content: center;
}
.app-bar {
	display: flex;
	justify-content: space-between;
	padding: 12px 18px;
	width: 100%;
	max-width: 504px;
	&__item {
		margin: 0 4px;
		display: flex;
		flex-direction: column;
		align-items: center;
		text-decoration: none !important;
		cursor: pointer;
		text-align: center;
		&:hover {
			i {
				color: lighten(#2f80ed, 20%);
			}
			span {
				color: lighten(#2f80ed, 25%);
			}
		}
		span {
			color: #ffffff;
			font-size: 10px;
			line-height: 12px;
			transition: 0.3s;
		}
		&.disabled {
			pointer-events: none;
			opacity: 0.2;
		}
		&.router-link-active {
			i,
			span {
				color: #fff;
			}
		}
	}

	&__icon {
		font-size: 24px;
		height: 24px;
		width: 24px;
		margin-bottom: 4px;
		color: #2f80ed;
		transition: 0.3s;
	}
}

@media (max-width: $md) {
	.footer-request-form {
		padding-top: 18px;
		padding-bottom: 18px;

		&_home {
			padding-bottom: 0;
		}
	}

	.footer-tagline {
		padding-top: 50px;
		padding-bottom: 50px;
		font-size: 24px;
		line-height: 32px;

		&__content {
			padding: 0 24px;
		}
	}
}
</style>
